import React from 'react';
import { X, MapPin, Calendar, User, Building, Clock } from 'lucide-react';
import { Button } from './ui/button';

const AdminOfferDetailModal = ({ offer, onClose }) => {
  if (!offer) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR');
  };

  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content-attente" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="admin-modal-header-attente">
          <h2 className="admin-modal-title-attente">Détail de l'offre - {offer.company}</h2>
          <Button
            onClick={onClose}
            variant="ghost"
            size="sm"
            className="admin-modal-close-btn-attente"
          >
            <X size={20} />
          </Button>
        </div>

        {/* Modal Body */}
        <div className="admin-modal-body-attente">
          {/* Status Badge */}
          <div className="admin-offer-status-section-attente">
            <div className="admin-offer-badge-attente admin-offer-badge-en-attente">
              EN ATTENTE DE VALIDATION
            </div>
          </div>

          {/* Offer Details */}
          <div className="admin-offer-details-attente">
            <div className="admin-offer-detail-section-attente">
              <h3 className="admin-section-title-attente">Informations générales</h3>
              
              <div className="admin-detail-grid-attente">
                <div className="admin-detail-item-attente">
                  <div className="admin-detail-label-attente">
                    <Building className="w-4 h-4" />
                    <span>Intitulé du poste</span>
                  </div>
                  <div className="admin-detail-value-attente">{offer.title}</div>
                </div>

                <div className="admin-detail-item-attente">
                  <div className="admin-detail-label-attente">
                    <User className="w-4 h-4" />
                    <span>Manager responsable</span>
                  </div>
                  <div className="admin-detail-value-attente">{offer.created_by_name || 'N/A'}</div>
                </div>

                <div className="admin-detail-item-attente">
                  <div className="admin-detail-label-attente">
                    <Calendar className="w-4 h-4" />
                    <span>Date de création</span>
                  </div>
                  <div className="admin-detail-value-attente">{formatDate(offer.created_at)}</div>
                </div>

                {offer.lieu_travail && (
                  <div className="admin-detail-item-attente">
                    <div className="admin-detail-label-attente">
                      <MapPin className="w-4 h-4" />
                      <span>Lieu de travail</span>
                    </div>
                    <div className="admin-detail-value-attente">{offer.lieu_travail}</div>
                  </div>
                )}

                {offer.date_arrivee && (
                  <div className="admin-detail-item-attente">
                    <div className="admin-detail-label-attente">
                      <Calendar className="w-4 h-4" />
                      <span>Date d'arrivée prévue</span>
                    </div>
                    <div className="admin-detail-value-attente">{formatDate(offer.date_arrivee)}</div>
                  </div>
                )}

                {offer.type_poste && (
                  <div className="admin-detail-item-attente">
                    <div className="admin-detail-label-attente">
                      <Clock className="w-4 h-4" />
                      <span>Type de poste</span>
                    </div>
                    <div className="admin-detail-value-attente">{offer.type_poste}</div>
                  </div>
                )}

                {offer.taux_horaire && (
                  <div className="admin-detail-item-attente">
                    <div className="admin-detail-label-attente">
                      <span>€</span>
                      <span>Taux horaire</span>
                    </div>
                    <div className="admin-detail-value-attente">{offer.taux_horaire}€/h</div>
                  </div>
                )}
              </div>
            </div>

            {/* Description */}
            {offer.description && (
              <div className="admin-offer-detail-section-attente">
                <h3 className="admin-section-title-attente">Description du poste</h3>
                <div className="admin-description-content-attente">
                  {offer.description}
                </div>
              </div>
            )}

            {/* Qualités attendues */}
            {offer.qualites_attendues && (
              <div className="admin-offer-detail-section-attente">
                <h3 className="admin-section-title-attente">Qualités attendues</h3>
                <div className="admin-description-content-attente">
                  {offer.qualites_attendues}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Modal Footer */}
        <div className="admin-modal-footer-attente">
          <div className="admin-modal-readonly-notice-attente">
            <span className="admin-readonly-text-attente">Mode consultation - Aucune action disponible</span>
          </div>
          <Button
            onClick={onClose}
            className="admin-btn-fermer-attente"
          >
            Fermer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminOfferDetailModal;